"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var _uuid = require("uuid");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var HOSTNAME_PREFIX = ["www", "secure", "media", "m"];
var RWD_ID_KEY = "rwd_id";
var RDW_ID_PREFIX = "RWD_";

function createRWDId() {
  var currentLocalStorage = localStorage.getItem(RWD_ID_KEY);

  var currentCookie = _jsCookie["default"].get(RWD_ID_KEY);

  if (!currentLocalStorage || !validate(currentLocalStorage)) {
    currentLocalStorage = currentCookie && validate(currentCookie) ? currentCookie : (0, _uuid.v4)();
    localStorage.setItem(RWD_ID_KEY, currentLocalStorage);
  }

  var cookieDomain = getDomain();

  var cookieProps = _objectSpread(_objectSpread({}, cookieDomain && {
    domain: cookieDomain
  }), {}, {
    expires: 365
  });

  _jsCookie["default"].set(RWD_ID_KEY, currentLocalStorage, cookieProps);
}

function getDomain() {
  var hostname = window && window.location ? window.location.hostname : null;

  if (hostname) {
    var _iterator = _createForOfIteratorHelper(HOSTNAME_PREFIX),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prefix = _step.value;

        if (hostname.indexOf("".concat(prefix, ".")) === 0) {
          hostname = hostname.replace(prefix, "");
          break;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return hostname;
}

function getRWDId() {
  return localStorage.getItem(RWD_ID_KEY) || _jsCookie["default"].get(RWD_ID_KEY) || null;
}

function validate(uuid) {
  return uuid.indexOf(RDW_ID_PREFIX) === 0 || (0, _uuid.validate)(uuid) && (0, _uuid.version)(uuid) === 4;
}

var _default = {
  createRWDId: createRWDId,
  getRWDId: getRWDId
};
exports["default"] = _default;